import type {
  CapabilityOverrideState,
  CapabilityScopeType,
} from "@/services/capabilitiesApi";

export type { CapabilityScopeType, CapabilityOverrideState };

export type CapabilityBulkDecision = "inherit" | "allow" | "deny";

export const SCOPE_TYPE_OPTIONS: {
  value: CapabilityScopeType;
  label: string;
}[] = [
  { value: "global", label: "Global" },
  { value: "source", label: "Source" },
  { value: "user", label: "User" },
];

export const OVERRIDE_STATE_OPTIONS: {
  value: CapabilityOverrideState;
  label: string;
}[] = [
  { value: "allow", label: "Allow" },
  { value: "deny", label: "Deny" },
];

export function formatCapabilityScope(
  scopeType: CapabilityScopeType,
  scopeId: string,
): string {
  return scopeId ? `${scopeType} (${scopeId})` : scopeType;
}
